import {
  initialState,
  Actions,
  State,
  DELETE_FILE,
  DELETE_FILE_SUCCESS,
  DELETE_FILE_ERROR,
  RESET_DELETE_FILE,
} from "../../types/files/delete";

const reducers = (state = initialState, action: Actions): State => {
  switch (action.type) {
    case DELETE_FILE:
      return {
        ...state,
        data: null,
        states: {
          loading: true,
          error: false,
          success: false,
        },
      };
    case DELETE_FILE_SUCCESS:
      return {
        ...state,
        data: action.payload,
        states: {
          loading: false,
          error: false,
          success: true,
        },
      };
    case DELETE_FILE_ERROR:
      return {
        ...state,
        data: null,
        states: {
          loading: false,
          error: action.payload,
          success: false,
        },
      };
    case RESET_DELETE_FILE:
      return {
        ...state,
        ...initialState,
      };
    default:
      return state;
  }
};

export default reducers;
